// extracted by mini-css-extract-plugin
module.exports = {"productContainer":"Products_productContainer__3Lk7G","productImage":"Products_productImage__dWeo8","productTitle":"Products_productTitle__17BDD"};